import { useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const MODULE_ICONS = {
    alarmas: '/icons/alarmas-192.png',
    diesel: '/icons/diesel-icon.svg',
    default: '/favicon.ico',
};

export function useModuleFavicon(module) {
    useEffect(() => {
        // Change favicon
        const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
        const prevHref = link.href;
        link.rel = 'icon';
        link.href = MODULE_ICONS[module] || MODULE_ICONS.default;
        if (!link.parentElement) document.head.appendChild(link);

        const appleLink = document.querySelector("link[rel='apple-touch-icon']");
        const prevApple = appleLink?.href;
        if (appleLink) appleLink.href = link.href;

        // Change manifest for PWA install
        const manifestLink = document.querySelector("link[rel='manifest']");
        const prevManifest = manifestLink?.href;
        if (manifestLink && module === 'alarmas') {
            manifestLink.href = '/manifest-alarmas.json';
        }

        // Check for custom icon
        if (module === 'alarmas') {
            fetch(`${API_URL}/api/alarmas/admin/app-config`)
                .then(r => r.json())
                .then(config => {
                    if (config?.custom_icon) {
                        link.href = '/icons/custom/icon-192.png?' + Date.now();
                        if (appleLink) appleLink.href = link.href;
                    }
                })
                .catch(() => {});
        }

        return () => {
            link.href = prevHref;
            if (appleLink && prevApple) appleLink.href = prevApple;
            if (manifestLink && prevManifest) manifestLink.href = prevManifest;
        };
    }, [module]);
}
